import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function MealCodes() {
  const [codes, setCodes] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = useCallback(() => api.get("/meal-codes").then((r) => setCodes(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      await api.patch(`/meal-codes/${edit.diet_code}`, edit);
      toast.success("Saved");
      setEdit(null);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="p-4 md:p-6 max-w-5xl">
      <Link to="/admin" className="text-xs text-muted-foreground hover:text-primary">← Admin</Link>
      <div className="my-3">
        <div className="label-tech mb-1">Configuration</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Meal & Diet Codes</h1>
      </div>

      <div className="card-flat border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/60 border-b border-border">
            <tr className="text-left label-tech">
              <th className="px-3 py-2">Diet</th>
              <th className="px-3 py-2 text-right">Units</th>
              <th className="px-3 py-2 text-right">Pack</th>
              <th className="px-3 py-2 text-right">Half Rack</th>
              <th className="px-3 py-2 text-right">Full Rack</th>
              <th className="px-3 py-2 text-right">PAR</th>
              <th className="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {codes.map((c) => (
              <tr key={c.diet_code} className="hover:bg-muted/30">
                <td className="px-3 py-2">
                  <div className="font-medium">{c.diet_code}</div>
                  <div className="text-xs text-muted-foreground">{c.diet_family}</div>
                </td>
                <td className="px-3 py-2 text-right font-mono">{c.units_per_meal}</td>
                <td className="px-3 py-2 text-right font-mono">{c.meals_per_pack}</td>
                <td className="px-3 py-2 text-right font-mono">{c.meals_per_half_rack}</td>
                <td className="px-3 py-2 text-right font-mono">{c.meals_per_full_rack}</td>
                <td className="px-3 py-2 text-right font-mono">{c.par_level}</td>
                <td className="px-3 py-2 text-right">
                  <button
                    onClick={() => setEdit({ ...c })}
                    className="text-primary text-xs font-bold uppercase tracking-widest hover:underline"
                  >Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {edit && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md grid place-items-center z-50 p-4">
          <div className="card-flat border-border p-5 max-w-lg w-full bg-card">
            <div className="label-tech mb-2">Edit diet {edit.diet_code}</div>
            <div className="grid grid-cols-2 gap-3">
              {["units_per_meal", "meals_per_pack", "meals_per_half_rack", "meals_per_full_rack", "par_level", "reorder_point"].map((k) => (
                <label key={k} className="text-xs">
                  <div className="label-tech mb-1">{k.replace(/_/g, " ")}</div>
                  <input
                    type="number"
                    value={edit[k] || 0}
                    onChange={(e) => setEdit({ ...edit, [k]: parseInt(e.target.value, 10) || 0 })}
                    className="w-full h-9 px-2 border border-border bg-background rounded-sm text-sm"
                  />
                </label>
              ))}
            </div>
            <div className="flex gap-2 mt-4">
              <button onClick={save} className="btn-hard flex-1 h-10 bg-primary text-primary-foreground text-xs font-bold uppercase tracking-widest rounded-sm hover:bg-orange-600 hover:text-white">Save</button>
              <button onClick={() => setEdit(null)} className="btn-hard h-10 px-4 border border-border rounded-sm text-xs font-bold uppercase tracking-widest hover:bg-muted">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
